<template>
  <span class="status-dot" :class="status"></span>
</template>
<script>
  export default {
    name: "StatusDot",
    props: {
      status: {
        type: String,
        default: "active",
      },
    },
  };
</script>
<style>
  .status-dot {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: var(--success);
  }
  .status-dot.draft {
    background-color: #fff;
  }
  .status-dot.active {
    background-color: var(--success);
  }
  .status-dot.inactive {
    background-color: darkgray;
  }
  .status-dot.unapproved {
    background-color: darkred;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/StatusDot.vue